module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Part One: This Is What We Had"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "90%",
      "vertical-align": "middle"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('h2', {
    staticClass: "chaptit"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#toc6",
      "id": "rtoc6"
    }
  }, [_c('span', {
    staticClass: "cb"
  }, [_vm._v("This Is What We Had")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%",
      "vertical-align": "middle"
    }
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#toc6"
    }
  }, [_vm._v("1")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Monopoly vs. Competition, 1840 to 1945")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("By about 1840, American railroads had stopped being a curiosity and were an accepted means of transportation. Explosive growth of the system east of the Mississippi in the two decades preceding the Civil War made railroads an essential component of economic life. The Union’s railroads helped to defeat the Confederacy, but in the period to century’s end, the South also participated vigorously in the expansion of the national network from coast to coast and border to border. It was a time when the railroad both connected and created communities and dominated as an economic and social force. Through efficient transportation of people and goods, the railroad induced economic development, and economic development made railroads ever more necessary. Author Robert Selph Henry noted the pace of change: “From the beginning of American railroad history to the period after the First World War, traffic on the rails consistently doubled every fifteen years, on the average.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-1",
      "id": "fn1-1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It was also a time of minimal regulation of business, and in this climate, the railroads’ domination led to abuses. By 1887, they were powerful monopolies led by legendary moguls and financial speculators: Jay Gould, J. P. Morgan, Cornelius and William K. Vanderbilt, and James J. Hill, among others. Their reputation as inflexible and ruthless earned them membership in a sinister pantheon—the “Robber Barons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Monopoly in the railroad industry should not have been a surprise. It had no competition; no other land transport mode matched its capacity, efficiency, and reliability. So, of course, its masters sought maximum financial benefit, often in conflict with each other. To be honest, the history of the industry would be pretty dull but for fascinating tales of corporate combat, thievery, and skulduggery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("These men are legendary in our nation’s history, but their ghosts haunt the railroad industry even today. While there were instances when monopolies "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("actually were beneficial, this did not matter to a government attitude that any monopoly should be broken up for the public good. Not every railroad owner or manager was greedy and corrupt, but the rail monopoly led politicians into a crusade that resulted in increasing regulation of the industry. Farmers in particular, who were a large constituency and had to rely on rail transportation, raised enough protest to spur legislation curbing both real and perceived railroad excesses.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The federal response was the 1887 Interstate Commerce Act, which specifically targeted the railroads. It created the five-member Interstate Commerce Commission (ICC), which began as a regulator but under subsequent laws gained exclusive power to approve or disapprove railroad services and rates."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-2",
      "id": "fn1-2"
    }
  }, [_vm._v("2")])]), _vm._v(" When it was a matter of continuing or discontinuing passenger train service, under its provisions, the Commission relied upon an ill-defined concept of what constituted “public convenience and necessity,” and this phrase was often invoked in discontinuance proceedings. How this standard was determined was not always consistent and often involved multiple public hearings in communities served by the service involving rail officials who had to defend their petitions with financial disclosures. Hearings officers’ decisions were not always based on the economics of operations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Commenting on the ICC’s governance of the industry, Burlington Route’s president Harry Murphy stated in 1963 that train discontinuance procedures for the Burlington were based on trains that actually lost money for the railroad. “That’s what’s at the heart of the railroad passenger problem,” he noted. “I doubt if passenger business nets much for the railroad. Of course, I don’t know how much passenger business would be left if the ICC formula were used. As a matter of fact, when we appear before the public commissions for taking trains off, if we used the ICC formula there would be objections and our case would have to be restated. Whenever we take off service, we cost-analyze what it would cost out-of-pocket to continue operations. Until a train actually loses money, we don’t attempt to take it off.” Murphy pointed out what passenger executives had contended for a long time: “If any other form of business operated under ICC rules such as have been set up for the passenger business, they’d go out of business, fast. But we’re obligated to perform. We can’t escape it—you have to have due regard for the public.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-3",
      "id": "fn1-3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Over time, ICC governance severely hampered the railroads’ ability to earn a profit because their monopolistic grip had been significantly weakened by a new early twentieth-century transportation technology: cars, trucks, and paved highways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Writing in the middle of World War II, Robert Selph Henry stated the issue: “There was a time when the problem, to some minds at least, was how to keep railroads from making too much money. The problem for the past quarter of a century has been how railroads might make money enough to enable them to finance the improvements they had to have if they were to stay in business as solvent, self-supporting enterprises. That is the real railroad problem of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("modern times—how railroads can make a living.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-4",
      "id": "fn1-4"
    }
  }, [_vm._v("4")])]), _vm._v(" Henry further noted that war traffic brought new prosperity but also that “the problem” would return and be worse after war’s end. Indeed, overregulation would not be seriously addressed until 1980, and since then the regulatory and economic climate for the railroads’ freight operations has been vastly improved. Up to that point, highway and even air freight competition, onerous taxation, constraints on ratemaking, loss of mail contracts, and battalions of federal and state regulators had weakened but fortunately did not kill the industry.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("There has always been something of a love-hate relationship between the railroads and the public. In the absence of highway and air competition, railroads had to do little to attract passenger traffic. Indeed, other than the introduction of the air brake, all-steel passenger car, and enclosed vestibules, there were few significant innovations in services up to around 1920. Prior to that, passengers were knocking down the doors, with passenger-miles and revenues increasing steadily."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-5",
      "id": "fn1-5"
    }
  }, [_vm._v("5")])]), _vm._v(" There was no incentive to increase patronage since it was so great already. Even the Pullman Company, which operated most of the comfortable, even elegant, sleeping cars on America’s railroads, took passengers for granted to a certain degree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This changed when the country entered the Great Depression following the stock market crash in October 1929. As the economic calamity worsened through the 1930s and ridership declined, the railroads and Pullman had to make greater efforts—such as introducing ice-sourced air conditioning and streamlined trains—to attract passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In the meantime, Henry Ford’s innovative method for producing inexpensive automobiles had spread to other firms. By the eve of the Depression, automotive technology had so improved, and the car had been made so useful by the introduction of publicly funded paved roads, that rail passenger traffic had declined by more than a third."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-6",
      "id": "fn1-6"
    }
  }, [_vm._v("6")])]), _vm._v(" People still rode the trains, especially for long-distance travel, but it was becoming apparent that the private auto’s effects on the rail passenger network would continue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In the 1930s, the railroads confronted another challenge: a precipitous decline in freight traffic and revenue—the lifeblood of any railroad. Oddly enough, their passenger trains helped ease the problem. Those trains generated a significantly smaller percentage of railroad revenues than freight trains, but passenger ticket sales provided immediate cash while settlement of freight charges took much longer. Passenger service remained marginally profitable during the 1920s, but by 1930, the traffic decline was accelerating; by 1933, passenger-miles were two-thirds and passenger revenues were three-fourths of what they had been in 1920. Revenue per train-mile was $1.28, less than half of the 1920 figure."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-7",
      "id": "fn1-7"
    }
  }, [_vm._v("7")])]), _vm._v(" Even so, railroads avoided large reductions in service in order to keep passenger cash coming in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Looming over the railroads was a real danger that alarmed both labor and management—the threat of nationalization. With large segments of the industry in bankruptcy, there was serious discussion of government ownership. Many outside railroading saw it as a viable option, but the railroads wanted to avoid it at all costs. The Burlington’s Ralph Budd (1879–1962), one of the industry’s most influential leaders at the time, did not mince words, saying that such a move would increase costs, lower productivity, and worsen service. All this had happened during federal government operation of the railroads during World War I but, even so, Depression-era nationalization might actually have evolved if the rails’ fortunes did not improve."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-8",
      "id": "fn1-8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f034-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Expression of confidence: New York Central’s Great Steel Fleet was lined up at La Salle Street Station on October 23, 1949, specifically for the company’s photographer, Ed Nowak. Left to right: the Wolverine, Pacemaker, New England States, Commodore Vanderbilt, and 20th Century Limited. A decade later, that confidence had evaporated.")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("NYC photo, Geoffrey H. Doughty Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Budd also declared that further regulation of the industry would only make matters worse."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-9",
      "id": "fn1-9"
    }
  }, [_vm._v("9")])]), _vm._v(" He cited the Emergency Railroad Transportation Act of 1933, which restricted the railroads’ ability to reduce costs by eliminating jobs. Further, a bill limiting freight train length to a maximum of seventy-five cars, “full crew” laws, and another bill providing a six-hour period to calculate a day’s pay were proof that government ownership would increase the cost of transportation. Such restrictions would make it impossible for the railroads to compete unless comparable constraints were enacted for their competitors."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-10",
      "id": "fn1-10"
    }
  }, [_vm._v("10")])]), _vm._v(" All the railroads wanted, in the words of actress Greta Garbo, was “to be left alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The Great Depression actually was beneficial for railroad passengers because it forced some companies to think differently about that business. In the Northeast, passenger-heavy lines such as the New York Central, the Pennsylvania, and the New Haven, and on some lines running westward from Chicago—the Union Pacific and the Burlington—became aware that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("their trains would not attract travelers unless the railroads got in touch with the times. Appealing to current aesthetic tastes could make traveling by train popular again. Because of this, beginning in the mid-1930s, the railroads engaged prominent industrial designers such as Henry Dreyfuss, Raymond Loewy, Otto Kuhler, and Walter Dorwin Teague to make their trains appealing through exterior streamlining and innovative interior design.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("These efforts, often kicked off by parading the new equipment around the country and allowing public walk-throughs, brought a rewarding blend of good press and increased patronage. The Burlington’s 1934 Pioneer Zephyr was one of several such trains and generated many column inches of ink with its dawn-to-dusk dash between Denver and Chicago. More importantly, it proved the viability of all–stainless steel construction, which ensured a long service life and would prove of great benefit to Amtrak."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-11",
      "id": "fn1-11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Even more was to follow. After the bombing of Pearl Harbor and the country’s plunge into war, traffic increased exponentially and railroads began earning unprecedented profits, even in their passenger services. The wartime surge seemed to suggest that passengers had come back and would not abandon trains for cars and airplanes after the war. So as early as 1943, the railroads began planning for a postwar traffic surge of both existing and new passengers, especially on long-distance trains, who would flock to new and modern streamlined equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The timing of this optimism was not entirely misplaced. A year or so into the war, the rebounding railroads were flush with cash, and many used these earnings to reduce funded debt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-12",
      "id": "fn1-12"
    }
  }, [_vm._v("12")])]), _vm._v(" This sound move reduced interest payments and allowed dividend increases to attract investment. Although outcome of the war was still uncertain, the mood changed dramatically with Allied successes, especially defeat of the Germans at Stalingrad in early 1943, the invasion of Sicily in mid-July, Hitler’s abandonment of the eastern front, and the fall of Mussolini and Italy’s surrender later that year. In 1944, when victory seemed almost in sight, railroads began sending preliminary orders to car builders for new equipment. Management recognized that wartime levels of passenger loadings and revenues would not continue but assumed that current travel habits and innovative new rolling stock would retain a good portion of both. Due to War Production Board restrictions still in effect, few equipment deliveries could be made until 1946. Even so, by early 1945, much of the industry was placing large orders. The New York Central, for example, ordered 721 cars that arrived between 1946 and 1950 and became its third-generation “Great Steel Fleet.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-13",
      "id": "fn1-13"
    }
  }, [_vm._v("13")])]), _vm._v(" The railroads were not doing things by halves.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Transportation Policy: Promotion, Regulation, and Preference")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In a country the size of the United States, efficient transportation is crucial to economic development and social well-being. However, there never has been a clear vision of a national transportation policy; what passes for one evolved "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("mainly in response to the urgings of various interests. This was due in part to the nature of the political process but also the belief that free enterprise would determine transportation’s course. Unfortunately, the variable character and vision of successive presidential administrations, the changeable composition of Congress, and a lack of comprehensive and identifiable goals made impossible the setting of a coherent policy. The result was a tug-of-war for two centuries over promotion and regulation of various transportation modes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Merriam-Webster’s dictionary defines “policy” in part as “prudence or wisdom in the management of affairs; management or procedure based primarily on material interest; a definite course or method of action selected from among alternatives and in light of given conditions to guide and determine present and future decisions.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-14",
      "id": "fn1-14"
    }
  }, [_vm._v("14")])]), _vm._v(" By any measure, our country, among the most advanced in the world, is sorely lacking a national transportation policy. What passed for one has really been just a series of legislative enactments rather than development of long-term plans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It was only with passage of the 1887 Interstate Commerce Act and creation of the ICC that regulation of railroads became a guiding principle,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-15",
      "id": "fn1-15"
    }
  }, [_vm._v("15")])]), _vm._v(" but federal involvement in transportation development already had a long history. One major undertaking was construction of the National Road from Cumberland, Maryland, to Vandalia, Illinois, between 1811 and 1834; another was aid to water transportation by improvement of natural waterways such as the Mississippi, Missouri, and Ohio Rivers. Federal involvement in railroad development was primarily through backing construction of the transcontinental Overland Route to California, completed in 1869, and by grants of public land (although in far smaller amounts than is generally perceived) to both encourage and help finance extension of other rail routes, mainly to other parts of the West Coast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The ICC’s original purpose was oversight and regulation of the railroads that eventually led to overregulation to the extent that it was difficult to provide satisfactory service at a profit."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-16",
      "id": "fn1-16"
    }
  }, [_vm._v("16")])]), _vm._v(" Then the early twentieth century brought new competitive pressures from the automobile and motortruck and a not unreasonable demand by citizens for government-funded paved roads. Passage by Congress of the Federal Aid Road Act in 1916 (authorizing $75 million—$717,981,618 in 2020—for construction, matched by state funding) brought the first of a series of massive expenditures of public funds for highway projects, with additional funding voted about every two years. In response, two million automobiles on the road in 1910 became close to ten million by 1920."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-17",
      "id": "fn1-17"
    }
  }, [_vm._v("17")])]), _vm._v(" Further competition appeared in the form of the intercity bus that, together with the auto, cut into the railroads’ passenger loadings on their various shorter (nonovernight) routes. Highway vehicles also all but removed the electric interurban railroad from the American landscape by 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Meanwhile, the ICC was having difficulty regulating more than 850 railroads with varying earning abilities. In an attempt to establish a baseline, the ICC initiated a comprehensive study of the transportation problem in 1915."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-18",
      "id": "fn1-18"
    }
  }, [_vm._v("18")])]), _vm._v(" There was talk of the government having to step in to control the railroads, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("which of course did occur later in World War I, but that was not well received, resulting in agreement that nationalization would result only in “inefficiency, extravagance, and local favoritism.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-19",
      "id": "fn1-19"
    }
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The 1915 study led to passage of the Transportation Act of 1920, which gave the ICC authority to fix rates so railroads could “earn a fair return upon the value of their properties used for transportation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-20",
      "id": "fn1-20"
    }
  }, [_vm._v("20")])]), _vm._v(" Based on a principle of private ownership in the interest of the public with regulation by the ICC, rates would be set high enough to pay for operations with a fair return on property; a labor board would be established to stabilize relations with employees; and railway securities would be permitted to earn a return that would attract investment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-21",
      "id": "fn1-21"
    }
  }, [_vm._v("21")])]), _vm._v(" By passing the 1920 law, Congress attempted to use regulation to strengthen the railroads financially, but it also sought to stabilize their development through consolidation—the idea of combining weaker railroads with stronger ones into large, robust regional systems. A lofty goal, perhaps, but it landed mostly with a thud. Opposition was widespread, and consolidation never went forward—at least, not until the late twentieth century, spurred by economic and competitive factors rather than government edict.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Efforts to help lessen the devastation of the Depression resulted in the Emergency Railroad Transportation Act in 1933. This was part of President Roosevelt’s New Deal initiative and promoted mergers and elimination of duplications in service, but its benefits were neutralized by a requirement that any economies not be realized at the expense of labor. The last thing Roosevelt wanted was more unemployment. Furthermore, the 1933 law blessed mergers but only so long as they did not adversely affect competition “as much as possible.” The result was a reversal of the positive effects of the Transportation Act of 1920 that allowed for a “fair return upon the value of railroad properties.” At the behest of the unions, the 1933 law also repealed the independent labor board meant to settle disputes. These provisions only undercut the railroads’ ability to make investments in their properties and attract new capital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Other regulatory reforms followed. The Railroad Retirement Act of 1935 set up a retirement and unemployment fund for railroad employees; and a 1938 law established an unemployment insurance act to allow payments even when railroaders were on strike. The premise of these and other acts was that “legislation was the best way to cure whatever was amiss.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-22",
      "id": "fn1-22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("A balanced transportation policy, however, remained elusive. Development of nonrail transportation modes through subsidies and directives became a standard government tool. Subsidies such as airport construction encouraged growth of an airline network, as did Post Office payments to airlines for carrying mail, a valuable traffic gradually siphoned off from the railroads. By 1925, airlines were delivering fourteen million letters and packages a year over a limited network. Making matters worse was the passage of the Contract Air Mail Act of 1925, called the “Kelly Act” after the bill’s sponsor, M. Clyde Kelly of Pennsylvania. It formally authorized the postmaster general to establish air mail contracts with the private sector."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-23",
      "id": "fn1-23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("On the passenger side, air travel and public fascination with it made a giant leap forward in May of 1927 when Charles Lindbergh (1902–74), the chief pilot for a company flying contract mail between Chicago and St. Louis, made his celebrated solo nonstop flight from New York to Paris. Lindbergh’s feat made him America’s first modern celebrity, other than movie stars, and spurred investment in aviation while increasing the popularity of air travel."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-24",
      "id": "fn1-24"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Regulatory policy shifted over time from controlling monopoly to controlling competition. The Truman-Wheeler Bill of 1939 not only acknowledged the railroad industry’s attempts to earn the cost of capital (interest payments) and pay for its fixed costs but also created the foundation for expanding the ICC’s ratemaking jurisdiction—this time to trucking and waterways. The Transportation Act of 1940 that followed sought to normalize carrier competition through regulation. However, this only led to a battle between the public’s interest in shipper protection and the private sector’s interest in carrier welfare. Its predecessor, the law passed in 1920, had been more in favor of the carriers’ interests."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-25",
      "id": "fn1-25"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("By 1940, of all the problems facing the railroads, subsidized competition emerged as the greatest threat."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-26",
      "id": "fn1-26"
    }
  }, [_vm._v("26")])]), _vm._v(" Commenting on transportation policy, Ralph Budd stated that “a fair and reasonably liberal policy, along the lines of the 1940 National Transportation Policy, administered in the same spirit, should afford an opportunity to earn sufficient revenues to carry out a reasonable program of maintenance and of gradual but constant and steady improvement of railroad properties. On the other hand, hostile legislation, or an unfriendly administration of the laws, particularly if coupled with undue favors to competing agencies of transportation, would retard, and might prevent, improvements in railroad facilities and services which are entirely feasible and will be made if not prevented by harmful legislation or administrative action. It rests with the public to decide what kind of railroad transportation it will have.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-27",
      "id": "fn1-27"
    }
  }, [_vm._v("27")])]), _vm._v(" Budd’s comments would be validated in due course.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Postwar Efforts")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Following World War II, as a result of a major government reorganization plan adopted in 1950, President Harry S. Truman ordered responsibility for the nation’s transport programs to be governed by the Commerce Department under the leadership of an undersecretary of transportation. This gave the country’s highest office a pivotal role in the setting of transportation policy, such as it was, through periodic “messages” to Congress on various needs for transportation programs and improvements."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-28",
      "id": "fn1-28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("One such message came from President John F. Kennedy and seemed to be a reaction to the “deteriorating railroad situation.” The industry’s condition was implicitly part of Kennedy’s focus in his message (written by special counsel Theodore Sorenson) delivered to Congress on April 4, 1962, where he laid out the objectives of a national transportation policy. In his introduction, Kennedy "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("noted that transportation policy “can and must be achieved primarily by continued reliance on unsubsidized privately owned facilities, operating under the incentives of private profit and checks on competition to the maximum extent possible. The role of public policy should be to provide a consistent and comprehensive framework of equal competitive opportunity that will achieve this objective at the lowest economic and social cost to the nation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-29",
      "id": "fn1-29"
    }
  }, [_vm._v("29")])]), _vm._v(" Kennedy accurately described the nation’s existing transportation policy as “a chaotic patchwork of inconsistent and often obsolete regulation. . . . Such policies must be reshaped in the most fundamental and far-reaching fashion.” Furthermore, he stated, “Excessive, cumbersome, and time-consuming regulatory supervision shackles and distorts management initiative. Some parts of the transportation industry are restrained unnecessarily; others are promoted or taxed unevenly and inconsistently. Our system of intercity public transportation—including railroads, trucks, buses, ships and barges, airplanes and pipelines—is seriously weakened today by artificial distortions and inefficiencies inherent in existing federal policies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-30",
      "id": "fn1-30"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In the following twenty-five pages, Kennedy outlined specific targets for Congressional attention—railroads, highways, aviation, and waterways—under the heading of “Even-handed Government promotion of intercity transportation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-31",
      "id": "fn1-31"
    }
  }, [_vm._v("31")])]), _vm._v(" Although the rail industry was not his principal focus, Kennedy’s comprehensive policy message was well timed. The railroads’ “deteriorating situation,” while involving a wide range of issues for freight railroads, necessarily included the troubles on the passenger side of the business. All passenger-carrying railroads had been negatively impacted by the ever-expanding interstate highway system and steadily increasing auto ownership. An extreme case was the New Haven Railroad that had tumbled into bankruptcy in 1961 and was in desperate straits. Liquidation was a real possibility, and its plight was stark evidence that the industry as a whole was in trouble."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-32",
      "id": "fn1-32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The New Haven’s troubles led to the Kennedy administration’s convening of the Whitman Commission. The Whitman report was as close as the administration would come to offering specific solutions but still was not a national policy statement. Unfortunately, Kennedy’s initiative for policy reform died along with the young president on November 22, 1963. Reforms would come, but at glacial speed, as the rail industry’s problems worsened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Meanwhile, the ICC had become a principal player in the merger cases of the 1960s—the beginning of what had been proposed as “consolidation” back in the 1920s. As other northeastern railroads began to falter, the ill-fated merger of the Pennsylvania and NYC railroads—the Penn Central—was one of the largest, not to mention the least successful. At the same time, mass transit emerged as a priority as highways became clogged with traffic. Urban mobility and high-speed trains began to gain acceptance and federal subsidies to aid implementation followed."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-33",
      "id": "fn1-33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("There was some true innovation on the part of the national government, however. The High-Speed Ground Transportation Act of 1965 provided funding"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v(" in the Northeast Corridor between Boston, New York, and Washington. With the Pennsylvania Railroad providing about two-thirds of the cost and the federal government the rest, the act helped launch the New York–Washington Metroliner. This truly was something new in North America: self-propelled (that is, nonlocomotive), electrically powered trains capable of higher than usual speeds. It was generally well accepted by passengers but did little in the way of solving the problem of constant deficits. The fact was that new equipment was only part of the answer. Something more had to be done to relieve the railroads of their passenger burden. The answer—ultimately a flawed one—was a dramatic departure from any previous attempt to aid the industry, and it took a crisis to provoke a solution.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f040-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Inherited by Penn Central from the Pennsylvania Railroad in 1968, the Metroliner program introduced high-speed rail passenger service between New York City and Washington, DC.")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("George H. Drury")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("A Different Place, 1945 to 1960")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Completing the story of what happened to the railroads’ passenger services requires a return to the end of the war in 1945. Peacetime seemed to promise the railroads a resurgence of passenger traffic and, for Americans generally, worldwide prosperity and a new era of peace. But the promises quickly faded; there would be neither a railroad renaissance nor prosperous world peace. Following the death of Franklin Roosevelt in April 1945, President Truman faced major postwar challenges: the spread of Soviet totalitarianism, the troubled creation of the State of Israel, and the specter of atomic war once the Soviets had the same weapons as the United States. Early in 1950, Senator Joe McCarthy began his crusade against alleged Communists, and in June, the Korean Peninsula exploded into war. At home, racial tensions surged. In such a disruptive national context, it is not surprising that the troubles of the railroads got little attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Running a populist presidential campaign in 1948, Truman claimed the barons of Wall Street, banks, and insurance corporations were partners with Republicans trying to destroy the reforms of the New Deal that had helped so many citizens. Thought to be inept and ill-prepared to be president, Truman had two challengers who split from his party; many believed he would lose the election. Although he had the "), _c('i', [_vm._v("Independence")]), _vm._v(", a Douglas DC-6, at his disposal, he chose to campaign by train. So did his opponent, Thomas Dewey. Truman had the advantage of barnstorming the country in presidential office car US No. 1, "), _c('i', [_vm._v("Ferdinand Magellan")]), _vm._v(". He made a fifteen-day, cross-country tour to California; a six-day visit to the Midwest; and then a ten-day trip to the Northeast and back to Missouri just before the election."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-34",
      "id": "fn1-34"
    }
  }, [_vm._v("34")])]), _vm._v(" Truman loved traveling by train; the railroad business car from which he held up the erroneous "), _c('i', [_vm._v("Chicago Tribune")]), _vm._v(" headline about his supposed loss of the election still exists in private ownership.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("We were indeed in a different place. The past was not prologue for the passenger train, despite the railroads’ optimism at war’s end. The conflict imposed significant lifestyle changes on the public, and victory came through broad home front sacrifice—beyond fearing for loved ones in the military—such as a halt in production of new cars and rationing of many consumer goods, gasoline, and rubber for tires. The pleasures of the “Sunday drive” were gone; people walked or took a streetcar or bus to work; they spent more time at home with family and in diversions such as reading, playing cards, going to the movies, or listening to the radio."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-35",
      "id": "fn1-35"
    }
  }, [_vm._v("35")])]), _vm._v(" Civilian auto production did not return until the 1946 model year and offered only warmed-over 1942 designs. With years of thrift and sacrifice at an end, Americans were poised for a new beginning; and although it did not seem so for a while, that promising future did not include the passenger train.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The war’s conclusion ended the railroads’ business boom and record profits and also brought a rapid rise in costs. The economy jerked from a war footing to a peacetime one, while strikes and material shortages occurred, hampering the railroads’ already stressed and faltering quality of service. Passenger traffic dropped precipitously following demobilization, and declines in freight traffic were steeper than anticipated. This plunged many railroads into deep trouble. In the Northeast especially, there were too many railroads competing for shrinking traffic as industry leaders looked to other regions for less militant unions and cheaper labor. In addition, much northeastern freight was shifting to trucks that became ever more efficient as public funding of roads continued. Operating commuter services only worsened railroads’ financial losses. Equipment was obsolete, service quality declined, and, as a result, so did public opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Meanwhile, by 1948 railroad car builders were finally delivering new streamlined products that had seemed a wise investment just a few years before. Even in the context of declining traffic, though, the railroads had no choice but to renew their fleets since the war had worn out almost everything on steel wheels. The new cars were the apex of modern rail passenger equipment and rolled through the 1960s, with around 1,200 of them serving as Amtrak’s initial fleet. Extremely well built, some stayed in that fleet for almost fifty years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("What appeared to be a new future for rail travel soon turned into more of a death march. Despite new equipment, heavy promotion, and a high level of onboard services, the railroads’ share of intercity travel declined over 75 percent between 1946 and 1956 and another 68 percent between 1956 and 1968. Some trains fared better than others, but it was clear that the traveling public had turned its back on steel-wheeled transportation.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Changing Times: Airline and Highway Development")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("After World War II, there was a dramatic change in how Americans traveled. It was not something new, just an acceleration of trends dating from the 1920s, but it did not augur well for the railroads. The automobile resumed its place in Americans’ lives, the embodiment of a move to personal mobility and the conveniences technology could offer. The passenger losses the railroads had experienced in the 1930s inevitably became more pronounced in the 1950s. Furthermore, competition in long-distance travel was no longer among railroads—it was with ever more prosperous airlines that thrived with public investment in air transport infrastructure.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent_para1"
  }, [_c('b', [_vm._v("Optimism Personified: The Postwar Car Orders")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('i', [_vm._v("Railway Age")]), _vm._v(" magazine regularly reported on the railroads’ postwar plans."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1f-1",
      "id": "fn1f-1"
    }
  }, [_vm._v("1")])]), _vm._v(" On November 1, 1946, America’s railroads had 2,598 passenger cars of all types on order. Of these, 192 were to be built in railroad company shops and 2,406 had been ordered from the “Big Three” car builders—American Car & Foundry (ACF), Pullman-Standard (P-S), and the Budd Company. One year later, orders totaled 3,026, with 171 to be built in railroad company shops and 2,855 by the Big Three.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("But change came fast. Only 184 additional cars had been ordered by mid-1948, and by year’s end only another 14 had been added. At that point, approximately 1,840 cars remained on order,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1f-2",
      "id": "fn1f-2"
    }
  }, [_vm._v("2")])]), _vm._v(" some contracted for as early as 1944. That was still a lot of cars, but the trend was clear: Chesapeake & Ohio (C&O) chairman Robert R. Young projected that the end of the passenger car industry was within sight,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1f-3",
      "id": "fn1f-3"
    }
  }, [_vm._v("3")])]), _vm._v(" a forecast not lost on ACF, P-S, and Budd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("However, they did survive for awhile. ACF shut down early in 1961, having moved to production of transit cars. P-S built its last single-level sleeping car in 1956, its last single-level coach in 1965, and closed out its career with Amtrak’s double-level Superliners between 1978 and 1981. Budd’s last products for Amtrak were three Viewliner car shells (two sleepers and one diner); the company continued building transit cars until the spring of 1987."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1f-4",
      "id": "fn1f-4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "notexb"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1f-1",
      "id": "fne1f-1"
    }
  }, [_vm._v("1")]), _vm._v(". “Passenger-Train Cars on Order,” "), _c('i', [_vm._v("Railway Age")]), _vm._v(", vol. 121, no. 20 (November 16, 1946): 797; and vol. 123, no. 20 (November 15, 1947): 188.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1f-2",
      "id": "fne1f-2"
    }
  }, [_vm._v("2")]), _vm._v(". “Talgo & Train X,” "), _c('i', [_vm._v("Wall Street Journal")]), _vm._v(" 133, no. 41 (February 18, 1949): 1, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1f-3",
      "id": "fne1f-3"
    }
  }, [_vm._v("3")]), _vm._v(". Young’s singular role in exploring new ways to offer passenger service—and, he figured, at a profit—is discussed at length in Part Two.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1f-4",
      "id": "fne1f-4"
    }
  }, [_vm._v("4")]), _vm._v(". Telephone interview with Cliff Black, May 28, 2020.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("The railroads faced what came to be called, even outside the industry, the “passenger problem.” At least nonrailroad business leaders and politicians were beginning to recognize that there indeed was a problem, even if solutions were a long time coming. For the rail industry, those solutions were few and fundamentals were too complex; by midcentury, the rail traffic freefall was well underway. There were occasional upswings during airline strikes and bad weather, but no one—not the railroads, nor regulators and politicians, nor state and local governments—stood up to say that railroad passenger service was a necessary component of the national transportation network.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In fact, it seemed that government in particular sought ways to make things worse. Congress passed the Federal Aid Highway Act of 1956, also called the National Interstate and Defense Highways Act, to connect every major American city. In cooperation with the states, it funded construction of the interstate highway network envisioned by President Eisenhower. The original authorization for construction was $25 billion ($239,327,205,882 in 2020) for a forty-one-thousand-mile system to be built over a period of ten years. The Highway Users Federation, made up of Standard Oil, Phillips Petroleum, Goodyear, Firestone, General Motors, and others, was a proponent and made sure the legislation fulfilled its members’ objectives. The resulting interstate system closely paralleled most major railroad main lines and further siphoned off both freight and passenger traffic. Although expanded beyond its original scope, in 2020 the total cost was estimated at more than $530 billion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Now federal and state governments were subsidizing private highway transportation on a much broader scale than ever, with no thought of the effects on the privately financed rail industry. The Interstate act further invigorated an already well-established highway lobby of contractors, suppliers, and trucking and bus companies, as well as the automotive industry, oil companies, and myriad businesses serving highway travelers. With a much louder political voice, these interests became increasingly influential while the railroads’ influence, by this time not particularly strong anyway, collapsed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Automobile travel by 1956 had far eclipsed rail and air, and, although railroads still carried slightly more passengers than airlines, rail’s share of the total was in steady decline."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-36",
      "id": "fn1-36"
    }
  }, [_vm._v("36")])]), _vm._v(" Calling trains outdated, the Highway Users Federation said that the future lay in highways. Furthermore, the railroads were an excellent source of tax revenue, particularly for various states and from a wartime ticket tax that would not be repealed for many years. The military, for whose benefit the interstate system was ostensibly proposed, dutifully turned to highways as a more economical way than rail to transport forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("For the airlines, the 1958 introduction of the Lockheed Electra turboprop and the Boeing 707 jet about the same time transformed the air travel markets. These innovative planes greatly advanced the reduction in travel times between major long-distance and intermediate cities, furthering the public’s obsession with convenience and saving time. Improved comfort was another factor, although this would change in the decades that followed. Ultimately, the passenger train simply could not compete. As NYC President Alfred Perlman remarked, “The supremacy of the jet airplane for long-distance travel lies beyond argument. And when we added the proliferation of limited access highways to the inherent convenience and flexibility of the private automobile, the demise of the long-haul passenger train was certain.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-37",
      "id": "fn1-37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f044-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("“Well, there she goes—the 5:08 to Los Angeles. Right on time!”")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("Edward Koren,")]), _vm._v(" The New Yorker"), _c('i', [_vm._v(". Copyright Condé Nast. Used by permission.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("But the airlines also had some serious safety problems. Before sophisticated navigation systems and air traffic control computers, high-profile crashes (often involving celebrities) were common; the 1956 collision of two planes over the Grand Canyon led to the Federal Aviation Act of 1958 and creation of the Federal Aviation Administration as a new regulator of the industry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("On the railroads, “modern” new trains still in many ways were trains of the past and could not compete for the travel dollar, so the future looked increasingly bleak. Passenger fares still brought in much-needed cash but less of it as trains carried fewer and fewer passengers. Rate increases granted by the ICC were often insufficient and lagged behind increasing costs, and the railroads were still treated as monopolies even though their total revenues could not earn the cost of capital. The state and federal governments appeared ambivalent at best as many communities, usually mounting little or no objection, lost passenger service. Still, discontinuance of NYC’s famed 20th Century Limited between New York City and Chicago in December 1967 after sixty-five years of continuous operation made national news. Some felt that American culture had lost part of its soul, and, of even more importance, it was one more instance of the passing of civility in travel.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent_para1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_c('b', [_vm._v("The Golden Age of the Automobile")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In 1957, the French philosopher Roland Barthes celebrated automobile design “as the exact equivalent of the great Gothic cathedrals” (apparently confirming that autos had spurred something of a religious fervor among people, especially Americans), a description that forty years before had applied to the country’s great railway terminals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-1",
      "id": "fn1ff-1"
    }
  }, [_vm._v("1")])]), _vm._v(" Car ownership in the United States went from 45 million in 1949 to 119 million in 1972."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-2",
      "id": "fn1ff-2"
    }
  }, [_vm._v("2")])]), _vm._v(" By 1955, American auto dealers were selling 7 million cars a year."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-3",
      "id": "fn1ff-3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In the race to attract car buyers, two- and three-tone combinations of turquoise, yellow, red, green, white, black, and pink had become standard color options. As air travel grew in popularity, car models took an aeronautical theme: Nash’s Airflyte series (1949), Oldsmobile’s Rocket V-8 (1949), and Hudson’s Jet (1953) and Jet-Liner (1954). Plymouth’s 1953 novel one-piece windshield, which soon gained wide acceptance, provided what Chrysler called “control tower visibility.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-4",
      "id": "fn1ff-4"
    }
  }, [_vm._v("4")])]), _vm._v(" By 1958, some Buick models had names that oddly evoked passenger trains (Century, Limited, and Special) but were soon eclipsed with introduction of the Air Born B-58 and the 1962 Electra. In a four-year period between 1956 and 1960, some carmakers offered push-button transmissions for the new push-button age, and by 1957, with a nod to the Space Age, auto brands offered fins that made cars look like rockets on wheels. By 1959, this fad, which proved fatal to some bicycle riders, was out of control, and when vertical fins reached their limits, they became horizontal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The first Holiday Inn opened in Tennessee in 1956, one of many chains that catered to highway travelers. Families could go to movie night in their cars at hundreds of drive-in theaters, the first of which opened in Camden, New Jersey, in 1933. They also could have lunch or dinner and go to church without leaving the family automobile. By the late 1950s, 90 percent of American families were taking holidays by car, and the American way of life had become equated with the car and the highway."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-5",
      "id": "fn1ff-5"
    }
  }, [_vm._v("5")])]), _vm._v(" By 1965, there were twenty thousand miles of interstate highways that cost an average of $1,141,000 ($9,426,073 in 2020) per mile, with some segments costing $50 million per mile."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1ff-6",
      "id": "fn1ff-6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "notexb"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-1",
      "id": "fne1ff-1"
    }
  }, [_vm._v("1")]), _vm._v(". Steven Parissien, "), _c('i', [_vm._v("The Life of the Automobile")]), _vm._v(" (New York: St. Martin’s Press, 2014), 186.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-2",
      "id": "fne1ff-2"
    }
  }, [_vm._v("2")]), _vm._v(". Parissien, 186.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-3",
      "id": "fne1ff-3"
    }
  }, [_vm._v("3")]), _vm._v(". Parissien, 187.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-4",
      "id": "fne1ff-4"
    }
  }, [_vm._v("4")]), _vm._v(". James M. Flammang, "), _c('i', [_vm._v("Cars of the Fabulous ‘50s")]), _vm._v(" (Lincolnwood, IL: Publications International, 2002), 142.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-5",
      "id": "fne1ff-5"
    }
  }, [_vm._v("5")]), _vm._v(". Parissien, 190–191.")]), _vm._v(" "), _c('p', {
    staticClass: "notex2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1ff-6",
      "id": "fne1ff-6"
    }
  }, [_vm._v("6")]), _vm._v(". Parissien, 192.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("General Motors and allies Standard Oil of California and Firestone Tire and Rubber Company launched National City Lines to acquire local rail transit systems and replace streetcars with buses. In 1925, it also bought a major stake in Yellow Coach Company, a supplier of Raymond Loewy–styled buses to Greyhound, the nation’s largest long-distance bus operator (the famous 1953 Scenicruiser was designed by Loewy). Greyhound competed with long-distance passenger trains,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-38",
      "id": "fn1-38"
    }
  }, [_vm._v("38")])]), _vm._v(" but its traffic base also eroded even after construction of the interstates.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent_para1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_c('b', [_vm._v("Travel Preferences")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Following demobilization in 1945–46, rail’s market share of intercity travel declined precipitously while travel by private automobile began its postwar ascent aided by a resurgent auto industry and taxpayer-paid improved roads and highways. Starting around 1950, a marked shift began toward subsidized air travel in the long-distance market from which rail never recovered.")])]), _vm._v(" "), _c('p', {
    staticClass: "capt1"
  }, [_c('a', {
    attrs: {
      "id": "tab1-1"
    }
  }, [_c('b', [_vm._v("Table 1.1")])])]), _c('a', {
    attrs: {
      "id": "tab1-1"
    }
  }, [_c('p', {
    staticClass: "capt2"
  }, [_c('b', [_vm._v("Intercity travel by mode")])]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    staticStyle: {
      "width": "51%"
    },
    attrs: {
      "alt": "",
      "src": "images/f046-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sourcet"
  }, [_c('i', [_vm._v("Source")]), _vm._v(": John B. Rae, "), _c('i', [_vm._v("The Road and Car in American Life")]), _vm._v(" (Cambridge, MA: MIT Press, 1971), 92–93.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Political Inaction")])]), _c('p', {
    staticClass: "indent_para"
  }, [_c('a', {
    attrs: {
      "id": "tab1-1"
    }
  }, [_vm._v("In 1951, a Senate subcommittee, under the leadership of Ohio Senator John Bricker, began investigating the railroads’ “passenger problem” for a report on national transportation policy. Published in 1952, the 1,500-page document confirmed most of the rail industry’s complaints, saying, “The railroads’ financial woes are primarily the result of unwise governmental policies rather than the operation of natural economic forces.” Furthermore, the railroad industry’s predicament was “adversely affected by lavish government subsidies to competing forms of transportation.” And, in a swipe at the ICC’s turn away from its primary function of safeguarding competition to favoring rails’ competitors, the report noted “the absence of fair and impartial regulation.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-39",
      "id": "fn1-39"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Despite the conclusions of the report, no action followed until July 1954 when President Eisenhower announced that his administration’s commerce secretary, Sinclair Weeks, would chair a committee to study “transport policy and organization.” The committee was to determine any changes necessary for fair and consistent treatment of all transport modes. When presented to the president in April 1955, the committee’s report was praised by the railroads despite the lack of any mention of help for them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-40",
      "id": "fn1-40"
    }
  }, [_vm._v("40")])]), _vm._v(" It did, however, make recommendations similar to those enacted twenty-five years later in the Staggers Rail Act of 1980. But only a few months later, Eisenhower unveiled his "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("unprecedented interstate highway initiative. With this, highway construction had become the nation’s de facto transportation policy.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Deficit Hearings and Some Action")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("By January 1958, the passenger deficit situation was so extreme that the Surface Transportation Subcommittee of the US Senate’s Interstate and Foreign Commerce Committee began hearings. Congress was finally convinced that the railroads were in real trouble, and passenger services might actually bankrupt many of them. Senator George Smathers of Florida stated at the outset, “Available statistics indicate that the American railroads are heading for serious trouble.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-41",
      "id": "fn1-41"
    }
  }, [_vm._v("41")])]), _vm._v(" What resulted was the Transportation Act of 1958, which allowed greater freedom to eliminate unprofitable trains and abandon branch lines. Prior to this act, the ICC train discontinuance process had been onerous and time-consuming, requiring railroads to present detailed loss accounting at public hearings in numerous affected communities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("However, the ICC was not entirely blind to the railroads’ crisis, although it avoided any allusion to its role in the problem. Responding to industry criticism by Young and other rail officials, the Commission had joined with Congress in 1956 to investigate the deficit problem. In its report (Docket No. 31954, May 18, 1959) the ICC stated, “The specific public need and demand for future railroad passenger service cannot be foretold. It is clear, however, that any degree of railroad participation in the travel market on a sound financial basis, requires adjustment of its services and facilities to determined needs.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-42",
      "id": "fn1-42"
    }
  }, [_vm._v("42")])]), _vm._v(" Further,")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The impetus given motor and air travel by Federal, State and local government promotional programs has unquestionably operated to the disadvantage of railroad passenger service. Vast highway, airport and airway modernization programs predicated upon anticipated public needs which are now underway, as well as a policy for continued subsidy to air carriers, offer little solace to an industry which is dependent upon private resources and which has witnessed the gradual erosion of its passenger market. It is not suggested that such programs are not meritorious and desirable in the public interest, but the fact is they do exist; they will, as in the past, have a pronounced impact upon railroad passenger service. Yet, there is little evidence of any comparable governmental effort to promote the public interest in railroad passenger service or to prevent or take into account competitive inequalities that may be induced by such promotional programs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-43",
      "id": "fn1-43"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("The report detailed nine recommendations that anticipated several that would come out of the Whitman Commission three years later: elimination of the 10 percent federal excise tax on passenger fares; income tax relief; reduction of the tax burden on railroad property; commuter operational subsidies by state and local communities; a study of “implications of the national transportation policy in connection with the procurement of passenger train services by the Post Office "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("Department, Department of Defense and other agencies of the Government”; elimination of duplicate trains, terminals, and facilities; experimentation with “new types of coaches, sleeping cars, dining and other facilities”; continuing “efforts to improve the attractiveness of railroad passenger service as a means of stimulating more adequate volume of traffic”; and, finally, that “every possibility of developing additional patronage should be fully and continually explored.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-44",
      "id": "fn1-44"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The report called for “an exploration of those public expenditures which operate to the disadvantage of the railroads. We adhere to the principle previously expressed that this country’s several forms of transportation should be treated equitably and that no one form should be preferred. We are of the view that the complete elimination of passenger-train ["), _c('i', [_vm._v("sic")]), _vm._v("] service would not be a solution in the public interest.” In conclusion the report stated, “A sense of urgency, therefore, compels us to advocate strongly the adoption of the recommendations outlined herein.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-45",
      "id": "fn1-45"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("And what was the rail industry’s response? In a film produced around 1960, Alfred Perlman spoke for the entire industry about subsidized competition. The NYC marketing department had watched in dismay as new sections of the New York State Thruway diverted freight and passenger traffic in its New York City–to–Buffalo market. Perlman, seated in what appeared to be his business car while the countryside raced past the window behind him, faced the camera to discuss progress made by the rail industry and the challenges it faced due to publicly financed highway and air competition. He closed with his main point: “What we have is a lopsided transportation policy on federal and state levels; a policy that is slowly squeezing the life out of our railroads. What do we ask? Well, that’s simple. We ask for an up-to-date fair transportation policy. We ask that all forms of transportation pay their way, as now only the railroads do. Or failing that, we ask the same tax benefits and the same government support under which other forms of transportation operate today.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-46",
      "id": "fn1-46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Explicit and Hidden Transportation Subsidies")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Perlman’s arguments remain valid in the third decade of the twenty-first century and warrant a brief examination. While the rail industry’s regulatory environment has improved since the Staggers Act (1980), balance in funding appropriation has not. Governments at all levels provide transportation subsidies, but it must be recognized that while some of the support is explicit, much is hidden, and this imbalance skews how transportation systems compete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This has affected the privately owned railroads since the early twentieth century. When public necessity spurred investment in better roads that drew freight and passengers from the railroads, no thought was given to effects on the rail industry because it was still so dominant and seemingly a monopoly. Between ICC regulation and ever-increasing government support for highways, waterways, and, later, airlines, the tax-paying railroad industry supported itself by profits and privately raised capital. Railroads gradually lost business, and their market share of both freight and passenger traffic declined, even as the economy grew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("The following table of explicit federal government subsidies covers the time period, especially the earlier part when public expenditure imbalance had the greatest impact on the railroads’ passenger services.")])]), _vm._v(" "), _c('p', {
    staticClass: "capt1"
  }, [_c('a', {
    attrs: {
      "id": "tab1-2"
    }
  }, [_c('b', [_vm._v("Table 1.2")])])]), _c('a', {
    attrs: {
      "id": "tab1-2"
    }
  }, [_c('p', {
    staticClass: "capt2"
  }, [_c('b', [_vm._v("Federal modal subsidies 1960–2017 (constant 2017 dollars)")])]), _vm._v(" "), _c('div', {
    staticClass: "tab1"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Mode")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("Total federal explicit subsidies ($)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("% of total   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Air")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("   510,948,000,000")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("   25.69")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Highway")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("1,155,588,000,000")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("   58.09")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Amtrak"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#aa1",
      "id": "a1"
    }
  }, [_vm._v("a")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("     54,999,000,000")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("    2.77")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Mass Transit")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("   267,416,000,000")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("  13.45")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("1,988,951,000,000")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "tabc"
  }, [_vm._v("100.00")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  })])])])])]), _c('p', {
    staticClass: "sourcet"
  }, [_c('a', {
    attrs: {
      "id": "tab1-2"
    }
  }, [_c('i', [_vm._v("Source")]), _vm._v(": Robert Nathan & Associates, “Federal Subsidies for Passenger Transportation 1960–2009,” appendix B, 51, 53, 57, 59, as of May 5, 2020, ")]), _c('a', {
    attrs: {
      "href": "http://www.bts.gov/explore-topics-and-geography/topics/government-transportation-financial-statistics",
      "target": "_blank"
    }
  }, [_vm._v("www.bts.gov/explore-topics-and-geography/topics/government-transportation-financial-statistics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sourcet"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#a1",
      "id": "aa1"
    }
  }, [_vm._v("a")])]), _vm._v(" Amtrak subsidies began in 1971; prior to that, the freight railroads paid for their own passenger services.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("The second table (below) shows the more recent history of such subsidies and includes state participation, based on federal Bureau of Transportation Statistics data.")]), _vm._v(" "), _c('p', {
    staticClass: "capt1"
  }, [_c('a', {
    attrs: {
      "id": "tab1-3"
    }
  }, [_c('b', [_vm._v("Table 1.3")])])]), _c('a', {
    attrs: {
      "id": "tab1-3"
    }
  }, [_c('p', {
    staticClass: "capt2"
  }, [_c('b', [_vm._v("Transportation expenditures, federal and state, 2007–17 (constant 2017 dollars)")])])]), _c('div', {
    staticClass: "tab1a"
  }, [_c('a', {
    attrs: {
      "id": "tab1-3"
    }
  }), _c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "tab1-3"
    }
  }), _c('a', {
    attrs: {
      "id": "ab3"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "91%"
    },
    attrs: {
      "alt": "",
      "src": "images/f049-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ab3"
    }
  })]), _c('a', {
    attrs: {
      "id": "ab3"
    }
  }), _c('p', {
    staticClass: "sourcet"
  }, [_c('a', {
    attrs: {
      "id": "ab3"
    }
  }, [_c('i', [_vm._v("Source")]), _vm._v(": ")]), _c('a', {
    attrs: {
      "href": "http://www.bts.gov/explore-topics-and-geography/topics/government-transportation-financial-statistics",
      "target": "_blank"
    }
  }, [_vm._v("www.bts.gov/explore-topics-and-geography/topics/government-transportation-financial-statistics")]), _vm._v(", as of May 5, 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "sourcet"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ab3"
    }
  }, [_vm._v("a")])]), _vm._v(" Amtrak total for these years, state support was not yet recognized by the DOT Bureau of Transportation Statistics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("The tables exclude hidden subsidies, such as tax-exempt bonds used to fund all forms of transportation, and other debt financing usually issued with tax-exempt status; transportation grants to all modes; government funding of aeronautical research and development; air traffic control; policing costs governed by agency budgets, such as Homeland Security; the effects of removing taxable land for airports, highways, and parking; airline pension funds bailed out by the federal Pension Benefit Guaranty Corporation; environmental costs due to air and other forms of pollution, including oil drilling on federal land; ethanol costs affecting the cost of food and farm subsidies; oil subsidies, including the cost of foreign wars to protect oil supplies; direct airline, Conrail, and Amtrak subsidies and grants (such as direct cash to airlines after the 9/11 attacks) before, during, and after the above period; and transfers from the General Fund (federal) to the Highway Trust Fund (the 2015 Highway Bill transferred $70 billion over five years to the Highway Trust Fund to make up for costs in excess of fuel tax revenues). Receipts from user charges offset some air, highway, and waterway use but are often portrayed as zeroing out some or all of the explicit subsidies while ignoring the hidden subsidies."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-47",
      "id": "fn1-47"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The complex weaving of explicit and hidden subsidies at the national and state levels calls for a comprehensive review of how public funds are spent relative to these expenditures’ long-term benefit. In his book "), _c('i', [_vm._v("Transportation in the U.S.: A Look Back, and Forward")]), _vm._v(", Gary Toth describes how transportation planners focused on highways without understanding the full implications of the effect on the greater good. He states, “The real point of transportation projects should be building successful communities and fostering economic prosperity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-48",
      "id": "fn1-48"
    }
  }, [_vm._v("48")])]), _vm._v(" In this context, to suggest only one area of concern to the authors of this book, policymakers may wish to consider the social and other impacts long-distance trains have on the rural communities they serve—and on those they don't serve but perhaps should.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("As at the federal level, hidden expenditures occur at the state level too, further skewing transportation policy and hiding the full costs of providing benefits to the railroads’ (especially Amtrak’s) competitors. In a study done at the Harvard Kennedy School, a working paper entitled "), _c('i', [_vm._v("The $64 Billion Massachusetts Vehicle Economy")]), _vm._v(" sheds light on state-level hidden subsidies. The paper’s data was through 2019 and identified $35.78 billion of state highway and vehicle costs (55.78 percent) out of a total of $64 billion expended in the Bay State for the study period. The balance, $28.4 billion, was borne by consumers to finance and operate vehicles. Of that $35.78 billion, just a third was covered by user charges. The balance fell on every family at an average rate of $14,000 per year, regardless of whether a family owned a vehicle. Total vehicle and highway costs include congestion, injury, death, the value of land set aside for highways (loss of real estate tax income), and the costs of financing and operating vehicles of pollution."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-49",
      "id": "fn1-49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Amtrak has long been required to disclose profit and loss statements as well as maintain its balance sheet. No other form of transportation is required to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("show both the explicit and hidden subsidies provided by the federal and state governments. There is no balance sheet or income statement for the interstate highway system. Neither are hidden costs reflected in air fares or highway access costs. This incomplete cost picture, coupled with Amtrak’s appearance as an annual budget line item, makes the company a ripe target for those who do not see value in supporting passenger rail services and integrating them with other transportation investments. It has become almost impossible for policymakers, even when motivated, to determine where the public can best be served by various transportation programs, given the skewing caused by unbalanced transportation subsidies, both explicit and hidden. Changes in federal policy—or preference—could foster a sea change in how passenger and freight transportation subsidies are allocated for all modes by making all such subsidies explicit and all costs visible to the voting public.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Whitman Commission")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In the face of such competition, northeastern railroads with large numbers of passengers were especially vulnerable because their freight services incurred higher costs and brought lower revenues than in other regions of the country. Freight profits—unpredictable at best—could not support passenger costs as well as on other railroads. This did not, however, sway government officials. They still theorized that freight revenues should and, worse, could cover passenger losses, thus absolving themselves of any responsibility—until time simply ran out for a major railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The Whitman Commission was a direct result of the second bankruptcy of the New York, New Haven & Hartford Railroad—the New Haven—on July 7, 1961. To industry insiders, the New Haven’s problems were widely known. The company earned about 42 percent of its revenue from passenger service and was in a unique and difficult position. The New Haven served close to 10 percent of the nation’s population in an area constituting less than 1 percent of its geographic area. It had emerged from bankruptcy in 1946, only to have everything of value, mostly real estate, stripped from it under periods of successive managements. Its large passenger deficits eroded any profits from its freight operations, which were mostly short-haul and vulnerable to motor carrier competition. Yet the New Haven, strategically located along the Northeast coast, was vital to the country’s economy and defense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Beginning in the mid-1950s, with two hurricanes that devastated its main lines and branches, the railroad suffered one financial crisis after another and had survived only because of emergency loans backed by the federal government. Following the departure of President Patrick B. McGinnis for the Boston & Maine in 1956, the New Haven’s physical and financial condition steadily worsened. Desperate for help, its new president, George Alpert, took a public stand: the government, with strong support from the Department of Defense,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-50",
      "id": "fn1-50"
    }
  }, [_vm._v("50")])]), _vm._v(" was giving ongoing support to the automobile, bus, trucking, and"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v(" aviation industries, so it only seemed logical that rail transport be included in order to retain a balanced transportation policy.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f052-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("“Great Scott! "), _c('u', [_vm._v("Now")]), _vm._v(" what’s happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("Peter Arno,")]), _vm._v(" The New Yorker"), _c('i', [_vm._v(". Copyright Condé Nast. Used by permission.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("Alpert’s position was eminently logical but created a dilemma for railroads and governments alike. Giving any kind of ongoing subsidy to a railroad in the 1950s was considered a form of socialism, something not to be tolerated, especially during the Cold War. Indeed, most other railroads were increasingly resistant to the idea of subsidies due to both the strings usually attached and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("the implied threat of nationalization. Granting subsidies to railroads as a part of government support of transportation would have required a major shift in political philosophy, not likely to occur overnight. But a true crisis, an immediate threat of disaster, can sharpen the mind—and so it was in the case of the New Haven. Its managers did not like the idea of subsidies but needed them to keep the railroad operating.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Fearing the New Haven would simply shut down in a strategic portion of the country, in early March 1962, Commerce Secretary Luther Hodges contacted Frederic B. Whitman, president of the Western Pacific Railroad, for help in addressing the “New Haven Railroad problem.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-51",
      "id": "fn1-51"
    }
  }, [_vm._v("51")])]), _vm._v(" Hodges asked Whitman to form a commission with representatives of seven profitable western railroads and locomotive builder Electro-Motive Division of General Motors to survey, assess, and make recommendations for action to be taken by both the New Haven’s trustees and the federal government. This was a new approach: asking the railroad industry what it needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The commission’s report included correspondence between Whitman and Hodges with this observation: “We are aware that the states involved have their problems with respect to raising sufficient tax monies to support their various governmental activities, but, on the other hand, the importance of the New Haven continuing as a successful private enterprise to serve the states and communities seems to us to outweigh the additional burden which would be placed on other taxpayers to make up the difference from other sources.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-52",
      "id": "fn1-52"
    }
  }, [_vm._v("52")])]), _vm._v(" The “various governmental activities,” of course, included the mounting costs of building and maintaining the public highways that put the New Haven in such a predicament. It was clear, however, that the commission expected the states to come up with support for the railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Another problem was management stability, although the report did not suggest a remedy. Beginning in 1948, the New Haven suffered administration changes around every two years. Lack of policy continuity, abrupt shifts in policy, forays into new and costly experimental passenger equipment, and loss of management talent and institutional knowledge all took their toll at a time when stability was needed. This was no way to run a railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The Whitman report was lengthy and detailed and dealt with problems specific to the New Haven: marketing, real estate, operations, management, labor, retirement of employees, and taxation. Most importantly, it was credible and persuasive and cleared the way for states to help the railroad. Although it primarily addressed the New Haven’s large commuter service, the report’s implication was that there should be a broader application of the principles it articulated, thus setting the tone for future dealings with other troubled railroads needing help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Regarding the New Haven’s commuter burden, the report stated, “If continuation of commuter service is deemed necessary or desirable by the states or local areas benefited, the railroad should not be expected or required to sustain such losses. Funds to make up those losses should be provided in some "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("form or other by the states and local areas served.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-53",
      "id": "fn1-53"
    }
  }, [_vm._v("53")])]), _vm._v(" One important point: the report also stated that the federal government should not be expected to cover those costs of operation. It would take much more serious “railroad problems” in later years to bring the national government to the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It is important to recognize how the New Haven’s impending demise and the value of the services it provided led to a significant change both in government approaches to regulation of rail transportation and in what had been a hands-off attitude toward railroad finances. Soon after the report came out, Connecticut, New York, and Massachusetts entered into agreements with the New Haven to compensate the railroad for commuter service losses. Further, by 1964, New York had passed legislation granting tax relief, and Massachusetts created the Massachusetts Bay Transportation Authority. In 1965 came the Connecticut Department of Transportation. Today, such major metropolitan commuter agencies as Metro North (New York and Connecticut), New Jersey Transit, SEPTA (Pennsylvania), METRA (Chicago), among others, and Amtrak itself can trace their origins to the New Haven’s bankruptcy. From its broken eggs, we managed to make some omelets.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Bigger Is Better (?): A Look at Penn Central")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In that troubled era for railroads, salvation appeared to be in merger, and “bigger” seemed certain to guarantee success. It had to; there were few favorable options. The combination of historic rivals NYC and Pennsylvania railroads in 1968 was a long time coming and very quickly served as a wake-up call for the government. Arriving at the point of merger took enormous effort on the part of both companies’ managements to convince labor, customers, lobbyists, lawyers, regulators, and politicians that merger was necessary for survival. The railroads’ passenger problem needed a solution and combining separate services in a regional fashion was one method being explored."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-54",
      "id": "fn1-54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Before the Penn Central (PC) merger could happen, however, connecting and competing railroads, organized labor, the Justice Department, the ICC, and the railroads’ customers had to have their doubts and fears mollified. Support from these groups came only through the creation of a tangled and often incomprehensible web of deals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("PC’s demise has been well documented; its 1970 bankruptcy was a pivotal event in many ways, but for the passenger train, it brought a true turning point. Struggling with passenger losses of tens of millions a year, in March 1969 (by which time PC was responsible also for all of the New Haven’s trains), the company issued a plan to abandon all of its passenger services west of Buffalo and Harrisburg, which then was followed by its filing for abandonment of its remaining thirty-four long-distance trains; this was in addition to fourteen proposed discontinuances already under consideration by the ICC (by this time only 1 percent of the public traveled by rail and 9 percent by air)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-55",
      "id": "fn1-55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("With the waning of passenger service on other railroads, Jim McClellan formed a committee at the newly created (1967) Federal Railroad Administration (FRA) embedded within the newly created (1966) Department of Transportation, led by Alan Boyd. Two railroad representatives, C&O/B&O’s William Howes (C&O/Baltimore & Ohio played a pivotal role in Amtrak’s creation as C&O/B&O and FRA headquarters were near each other; even so, the railroad’s chairman, Hays Watkins, did not want any government money) and Illinois Central’s Paul Reistrup, were asked to join, the only railroaders on the committee. The realization that passenger service in the country was collapsing (the railroad-owned Railway Express Agency was also failing and the Pullman Company was in the process of ending operations) forced the FRA to conduct a study to find out what was happening, and what the government could or should do."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-56",
      "id": "fn1-56"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("There was no question that the railroads were hurting, but by how much? The United States Post Office Department was closing down mail sorting aboard Railway Post Office (RPO) cars and shifting first-class mail to the airlines, leaving low-revenue second-class mail on the trains. The reason, at least in part, was that reliability of service and ever-decreasing numbers of available trains made it hard to meet Post Office performance requirements. Another factor was the introduction of the zip code in anticipation of automated mail sorting. To the Post Office, the RPO, with its expensive crews sorting mail by hand in transit, was obsolete."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-57",
      "id": "fn1-57"
    }
  }, [_vm._v("57")])]), _vm._v(" Revenues from RPO services were paying operating costs for many passenger trains and were the only reason they kept running. That did not seem to matter to Postmaster Lawrence O’Brien, and loss of so much of the mail further deepened the passenger train dilemma.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Not-So-Hidden Problems")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The threat of Penn Central to stop its trains and the loss of mail contracts had a big impact. While many of the railroads’ problems were obvious—declining passenger traffic, overregulation, high taxation, and labor militancy—there were other less visible ones. Like Daphne du Maurier’s title character in "), _c('i', [_vm._v("Rebecca")]), _vm._v(", while never seen, these problems were always lurking offstage: passenger fares were not keeping pace with inflation, costs of labor and materials kept rising, and an aging car fleet required ever more maintenance and repair. The railroads were caught in an untenable position, hurtling down a dead-end road from which there seemed no escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The cost of labor was a particular problem that consumed more dollars of passenger revenues. This was partly because in negotiation of wages, benefits, and work rules, the railroads frequently made concessions on the freight side to attain labor peace and keep the trains rolling; but this resulted in reduced profits needed to support the passenger side, where similar concessions made running those trains more expensive. A significant part of the rise in labor costs lay in the diabolically complex labor agreements and provisions for conferences, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("mediation, arbitration, and factfinding buried within the Railway Labor Act of 1926. Presidential emergency boards, arbitration boards, and cooling-off periods were frequently employed to avert strikes and often resulted in more complex rules and “awards” that fostered inefficiency and ultimately made it more expensive to operate trains. This did have a positive effect, for the railroads, anyway, of validating their arguments when petitioning to eliminate trains that did not pay their way, but the ICC did not always grant the desired discontinuances. The railroads also could petition the ICC for passenger fare increases, but this took time and often came too late to address rising labor costs, and fare hikes had the additional effect of discouraging ridership.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Then there was an even more pressing problem on the threshold of the 1970s: the looming prospect of having to invest in new passenger equipment. Although it can be argued that some of the larger railroads were willing to tolerate a certain level of deficits in order to maintain cash flow and retain control of their passenger operations, even for them the prospect of renovating existing or purchasing new passenger equipment was daunting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In addition to all the problems they faced, various railroads had different views among them about running passenger trains. Some wanted out, while others did not. Curiously, some operating officers believed passenger operations “forced railroads into operating discipline they otherwise would not have. They wanted this,” said Bill Howes."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-58",
      "id": "fn1-58"
    }
  }, [_vm._v("58")])]), _vm._v(" On the Seaboard Air Line Railroad, for example (later the Seaboard Coast Line after merger with the Atlantic Coast Line), the passenger problem was not so much a lack of revenues or demand, it was the increasing expenses that all the railroads were enduring. “The traffic was there,” said Howes. Other passenger railroads too had decent traffic levels, but for all of them, the economic realities were stark and piling up ever faster, and something had to change."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-59",
      "id": "fn1-59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Killing the Passenger Train?")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('i', [_vm._v("Trains")]), _vm._v(" magazine began publishing in 1940. Railroad enthusiasts have always been part of its reader base, of course, but it has the respect of those in the railroad industry too. In the issue for April 1959, the magazine’s longtime editor, the late David P. Morgan, ran a thirty-eight-page study, carefully researched and documented, titled “Who Shot the Passenger Train?” While it was no pro-train puff piece, the article made it clear that its author supported passenger rail and that, if the right steps were taken, there was a future for the passenger train in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Morgan described the railroads’ trains as “a privately financed and taxpaying business providing a public service at less than cost.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-60",
      "id": "fn1-60"
    }
  }, [_vm._v("60")])]), _vm._v(" In analyzing the problem—in probably the best assessment by anyone of the era—he cited much familiar evidence: the reality of passenger deficits and the threat they posed to the rail industry, the unreliability of the “ICC Formula” (discussed later) in assessing the actual deficits, regulatory strangleholds, public subsidy "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("of air and highway travel, and the tax-exempt status of much of the air and highway infrastructure, while railroads had to buy and then build their own and then were taxed for owning it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Even in the context of the well-documented (and obvious) American love affair with the automobile and the speediness of air travel, Morgan said, a national network of passenger trains could be established on a sound economic basis that would enable continuation of the public service they performed. He proposed several ideas: run passenger trains as a separate business, even a separate national corporation or a collection of regional ones; separate all the commuter services from the corridor and intercity ones; invest in new equipment with lower operating and crewing costs and bidirectional capability; keep carrying the mail but abandon the costly en route sorting of it; and give passenger trains “equal treatment”—if other modes got subsidies, trains should too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Morgan’s article must have been widely read, but from 1959 to 1970, as we have seen, there was no real progress other than relieving the railroads of the commuter burden. Even then, this happened only when it became a crisis, the typical American way of dealing with problems. With the coming of Amtrak, however, Morgan’s eleven-year-old proposals began to look like new ideas: a separate corporation to run the trains; new equipment, some modeled after traditional separate-car design, others as bidirectional and high-speed equipment (Metroliner and TurboTrain); and nonsorted mail, which did return to the rails for awhile before being discarded by Amtrak. As for “equal treatment,” the annual appropriations that have kept Amtrak going—sometimes better and sometimes worse—are by any measure at least some version of leveling the playing field.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("But the American public—and Amtrak—are still hobbled by Morgan’s answer to “Who Shot the Passenger Train”: it is all of us, and it is the result of perceiving the passenger train as somehow outmoded, part of the past with no place in a prosperous future—except in Europe and Asia. How did this happen? “Not deliberately, not in collusion. . . . There is no one culprit, no group of whom it can be fairly said, ‘They did it.’ The psychological obsolescence that has overtaken the passenger train stems from a classic failure of all concerned to get the big picture.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fne1-61",
      "id": "fn1-61"
    }
  }, [_vm._v("61")])]), _vm._v(" It would take a great deal of hand-wringing and a lot of hard work to find even the beginning of a solution.")]), _vm._v(" "), _c('p', {
    staticClass: "notex"
  }, [_vm._v("Part One Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-1",
      "id": "fne1-1"
    }
  }, [_vm._v("1")]), _vm._v(". Robert Selph Henry, "), _c('i', [_vm._v("This Fascinating Railroad Business")]), _vm._v(" (Indianapolis and New York: Bobbs-Merrill, 1943), 433–434.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-2",
      "id": "fne1-2"
    }
  }, [_vm._v("2")]), _vm._v(". The ICC expanded its authority to include other modes, including aviation, until the creation of the Civil Aeronautics Board in 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-3",
      "id": "fne1-3"
    }
  }, [_vm._v("3")]), _vm._v(". “Revenue Firm, Deficit Down,” "), _c('i', [_vm._v("Railway Age")]), _vm._v(" 154, no. 19 (May 20, 1963): 20.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-4",
      "id": "fne1-4"
    }
  }, [_vm._v("4")]), _vm._v(". Henry, 435.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-5",
      "id": "fne1-5"
    }
  }, [_vm._v("5")]), _vm._v(". “Passenger Service Improvement Sets New Record,” "), _c('i', [_vm._v("Railway Age")]), _vm._v(" 109, no. 20 (November 16, 1940): 705–707.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-6",
      "id": "fne1-6"
    }
  }, [_vm._v("6")]), _vm._v(". “Passenger Service Improvement Sets New Record,” 705–707.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-7",
      "id": "fne1-7"
    }
  }, [_vm._v("7")]), _vm._v(". “Passenger Service Improvement Sets New Record,” 705–707.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-8",
      "id": "fne1-8"
    }
  }, [_vm._v("8")]), _vm._v(". Ralph Budd 1935 speech before the American Association of Railroad Superintendents, in Richard "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("C. Overton, "), _c('i', [_vm._v("Perkins/Budd: Railway Statesmen of the Burlington")]), _vm._v(" (Westport, CT: Greenwood Press, 1982), 146.")])]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-9",
      "id": "fne1-9"
    }
  }, [_vm._v("9")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-10",
      "id": "fne1-10"
    }
  }, [_vm._v("10")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-11",
      "id": "fne1-11"
    }
  }, [_vm._v("11")]), _vm._v(". Retired in 1960 to Chicago’s Museum of Science and Industry, the Pioneer Zephyr can be visited there today, including its restored interior.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-12",
      "id": "fne1-12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('i', [_vm._v("Moody’s Transportation Manual")]), _vm._v(" (New York: Moody’s Investor Service, 1956), a–9.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-13",
      "id": "fne1-13"
    }
  }, [_vm._v("13")]), _vm._v(". W. David Randall, "), _c('i', [_vm._v("Streamliner Cars")]), _vm._v(", 3 vols., (Godfrey, Illinois: RPC), 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-14",
      "id": "fne1-14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("Webster’s New World Dictionary of the American Language")]), _vm._v(", 2nd College Edition (New York: World, 1968), 1102.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-15",
      "id": "fne1-15"
    }
  }, [_vm._v("15")]), _vm._v(". Byron Nupp, "), _c('i', [_vm._v("National Transportation Policy in the United States—An Analysis of the Concept")]), _vm._v(", University of Denver Law Journal, HeinOnline, pp. 145–146.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-16",
      "id": "fne1-16"
    }
  }, [_vm._v("16")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 124–125.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-17",
      "id": "fne1-17"
    }
  }, [_vm._v("17")]), _vm._v(". John B. Rae, "), _c('i', [_vm._v("The Road and Car in American Life")]), _vm._v(" (Cambridge, MA: MIT Press, 1971), 38.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-18",
      "id": "fne1-18"
    }
  }, [_vm._v("18")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 124–125.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-19",
      "id": "fne1-19"
    }
  }, [_vm._v("19")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-20",
      "id": "fne1-20"
    }
  }, [_vm._v("20")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-21",
      "id": "fne1-21"
    }
  }, [_vm._v("21")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 122.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-22",
      "id": "fne1-22"
    }
  }, [_vm._v("22")]), _vm._v(". Overton, "), _c('i', [_vm._v("Perkins/Budd")]), _vm._v(", 135.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-23",
      "id": "fne1-23"
    }
  }, [_vm._v("23")]), _vm._v(". Daniel Rust, presentation at the Lexington Group for Transportation History, October 23, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-24",
      "id": "fne1-24"
    }
  }, [_vm._v("24")]), _vm._v(". Rust, presentation.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-25",
      "id": "fne1-25"
    }
  }, [_vm._v("25")]), _vm._v(". Nupp, 150.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-26",
      "id": "fne1-26"
    }
  }, [_vm._v("26")]), _vm._v(". Richard C. Overton, "), _c('i', [_vm._v("Burlington Route")]), _vm._v(" (Lincoln: University of Nebraska Press, 1965), 547.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-27",
      "id": "fne1-27"
    }
  }, [_vm._v("27")]), _vm._v(". Overton, "), _c('i', [_vm._v("Burlington Route")]), _vm._v(", 547.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-28",
      "id": "fne1-28"
    }
  }, [_vm._v("28")]), _vm._v(". Nupp, 153.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-29",
      "id": "fne1-29"
    }
  }, [_vm._v("29")]), _vm._v(". John F. Kennedy, "), _c('i', [_vm._v("Special Message to Congress on Transportation")]), _vm._v(" (Boston: Presidential Papers, John F. Kennedy Library), 3.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-30",
      "id": "fne1-30"
    }
  }, [_vm._v("30")]), _vm._v(". Kennedy, 4.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-31",
      "id": "fne1-31"
    }
  }, [_vm._v("31")]), _vm._v(". Kennedy, 6.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-32",
      "id": "fne1-32"
    }
  }, [_vm._v("32")]), _vm._v(". The New York, Ontario & Western, which had survived on government loans before and after the war, was liquidated in 1957, the first major railroad to do so. That same year the Chicago, Aurora & Elgin, a major electric interurban in the Chicago area, exited the passenger business and was liquidated in 1959. In 1961, southern California lost its last commuter rail service, the Pacific Electric, and in 1963, the Chicago, North Shore & Milwaukee was liquidated.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-33",
      "id": "fne1-33"
    }
  }, [_vm._v("33")]), _vm._v(". Nupp, 157.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-34",
      "id": "fne1-34"
    }
  }, [_vm._v("34")]), _vm._v(". David McCullough, "), _c('i', [_vm._v("Truman")]), _vm._v(" (New York: Simon & Schuster, 1992), 654.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-35",
      "id": "fne1-35"
    }
  }, [_vm._v("35")]), _vm._v(". Doris Kearns Goodwin, "), _c('i', [_vm._v("No Ordinary Time")]), _vm._v(" (New York: Simon & Schuster, 1994), 355–359.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-36",
      "id": "fne1-36"
    }
  }, [_vm._v("36")]), _vm._v(". Rae, 92–93.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-37",
      "id": "fne1-37"
    }
  }, [_vm._v("37")]), _vm._v(". Stover, 221.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-38",
      "id": "fne1-38"
    }
  }, [_vm._v("38")]), _vm._v(". Parissien, 192.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-39",
      "id": "fne1-39"
    }
  }, [_vm._v("39")]), _vm._v(". Charles O. Morgret, "), _c('i', [_vm._v("Brosnan: The Railroads’ Messiah")]), _vm._v(", Volume 1 (Great Barrington, MA: Vantage, 1997), 229.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-40",
      "id": "fne1-40"
    }
  }, [_vm._v("40")]), _vm._v(". Morgret, 312.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-41",
      "id": "fne1-41"
    }
  }, [_vm._v("41")]), _vm._v(". 1957 New York Central Railroad Annual Report, 24.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-42",
      "id": "fne1-42"
    }
  }, [_vm._v("42")]), _vm._v(". Association of American Railroads, "), _c('i', [_vm._v("What Can be Done to Solve . . . THE Railroad Passenger Train Problem; Recommendations of the Interstate Commerce Commission")]), _vm._v(", 1959, 4.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-43",
      "id": "fne1-43"
    }
  }, [_vm._v("43")]), _vm._v(". Association of American Railroads, "), _c('i', [_vm._v("What Can be Done to Solve")]), _vm._v(", 4, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-44",
      "id": "fne1-44"
    }
  }, [_vm._v("44")]), _vm._v(". Association of American Railroads, "), _c('i', [_vm._v("What Can be Done to Solve")]), _vm._v(", 9, 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-45",
      "id": "fne1-45"
    }
  }, [_vm._v("45")]), _vm._v(". Association of American Railroads, "), _c('i', [_vm._v("What Can be Done to Solve")]), _vm._v(", 10, 11.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-46",
      "id": "fne1-46"
    }
  }, [_vm._v("46")]), _vm._v(". YouTube Video, "), _c('i', [_vm._v("The Big Train")]), _vm._v(", MPO Production, accessed August 27, 2020, "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=eT9H44ytagw&ab_channel=DocumentaryClassics",
      "target": "_blank"
    }
  }, [_vm._v("https://www.youtube.com/watch?v=eT9H44ytagw&ab_channel=DocumentaryClassics")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-47",
      "id": "fne1-47"
    }
  }, [_vm._v("47")]), _vm._v(". “Federal Subsidies for Passenger Transportation,” accessed June 19, 2020, "), _c('a', {
    attrs: {
      "href": "http://bts.gov/sites//bts.dot.gov",
      "target": "_blank"
    }
  }, [_vm._v("bts.gov/sites//bts.dot.gov")])]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-48",
      "id": "fne1-48"
    }
  }, [_vm._v("48")]), _vm._v(". “Transportation in the U.S.: A Look Back, and Forward,” January 1, 2009, Gary Toth, quoted in "), _c('i', [_vm._v("Project for Public Spaces")]), _vm._v(", accessed November 18, 2020, "), _c('a', {
    attrs: {
      "href": "http://www.pps.org",
      "target": "_blank"
    }
  }, [_vm._v("www.pps.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-49",
      "id": "fne1-49"
    }
  }, [_vm._v("49")]), _vm._v(". “The $64 Billion Massachusetts Vehicle Economy,” Harvard Kennedy School, Olsen, Stevie, Berkaw, Charland, Patton, Bilmes 2019. "), _c('a', {
    attrs: {
      "href": "http://www.hks.harvard.edu/publications/64-Billion-Massachusetts-Vehicle-Economy",
      "target": "_blank"
    }
  }, [_vm._v("www.hks.harvard.edu/publications/64-Billion-Massachusetts-Vehicle-Economy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-50",
      "id": "fne1-50"
    }
  }, [_vm._v("50")]), _vm._v(". The military has often played a vital role in transportation. Railroads were used extensively in times of war. The airline industry was a beneficiary as well. Passenger aircraft owe their origins to the government’s postal service and the military; jet aircraft development also was due to the military.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-51",
      "id": "fne1-51"
    }
  }, [_vm._v("51")]), _vm._v(". US Department of Commerce, "), _c('i', [_vm._v("Report of the Railroad Professional Survey Group")]), _vm._v(", 1962, v.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-52",
      "id": "fne1-52"
    }
  }, [_vm._v("52")]), _vm._v(". US Department of Commerce, "), _c('i', [_vm._v("Report")]), _vm._v(", 21.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-53",
      "id": "fne1-53"
    }
  }, [_vm._v("53")]), _vm._v(". US Department of Commerce, "), _c('i', [_vm._v("Report")]), _vm._v(", 31.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-54",
      "id": "fne1-54"
    }
  }, [_vm._v("54")]), _vm._v(". Combining passenger services was not a new idea. The consulting firm of Robert Heller & Associates had conducted studies in the early 1950s that found considerable synergy in a combined New York Central, Pennsylvania, and Baltimore & Ohio passenger operation, but the proposal was never followed through.")])]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-55",
      "id": "fne1-55"
    }
  }, [_vm._v("55")]), _vm._v(". Rae, 92–93.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-56",
      "id": "fne1-56"
    }
  }, [_vm._v("56")]), _vm._v(". Personal interview with William F. Howes, February 12–13, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-57",
      "id": "fne1-57"
    }
  }, [_vm._v("57")]), _vm._v(". Telephone interview with William F. Howes, June 9, 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-58",
      "id": "fne1-58"
    }
  }, [_vm._v("58")]), _vm._v(". Howes, February 12–13, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-59",
      "id": "fne1-59"
    }
  }, [_vm._v("59")]), _vm._v(". Howes, February 12–13, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-60",
      "id": "fne1-60"
    }
  }, [_vm._v("60")]), _vm._v(". David P. Morgan, “Who Shot the Passenger Train?” "), _c('i', [_vm._v("Trains")]), _vm._v(", (April 1959): 14–51.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#fn1-61",
      "id": "fne1-61"
    }
  }, [_vm._v("61")]), _vm._v(". Morgan, 14–51.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d48804","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter01.vue
// module id = 111
// module chunks = 0